import Vue from 'vue'
export default {
  namespaced: true,
  state: {
    deviceInfo: ''
  },
  mutations: {
    setDeviceInfo(state, data) {
      state.deviceInfo = data
    }
  },
  actions: {

  },
  getters: {

  },
}
